// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTop_backToTop__e8FgY","show":"BackToTop_show__o0141"};